<template>
  <v-card width="400">
    <v-btn
      style="text-transform: none"
      text
      class="float-right text--secondary text-caption mt-2"
      v-if="!caughtUp"
      @click="dismissAllNotifications"
    >
      Clear All
    </v-btn>
    <v-card-subtitle class="mb-0 pb-0 text--secondary">Notifications</v-card-subtitle>

    <v-card-text v-if="caughtUp" style="text-align: center" class="align-center justify-center pt-6 pb-8">
      <div>
        <v-icon color="darkest" large>mdi-bell-outline</v-icon>
      </div>
      <div class="text-h6 darkest--text">All caught up!</div>
    </v-card-text>

    <v-card-text v-else class="notification-container">
      <div class="scrollable-list">
        <v-list dense>
          <v-list-item
            v-for="(notification, index) in notifications"
            :key="index"
            @click="navigate(notification)"
            :class="{ 'clickable-notification': notification.link }"
            class="pr-0"
          >
            <v-list-item-content class="list-item-content-custom">
              <v-list-item-title class="text-caption title-container">
                <div>{{ notification.details }}</div>
                <v-icon v-if="notification.link" class="ml-1" x-small>mdi-open-in-new</v-icon>
              </v-list-item-title>

              <v-list-item-subtitle class="text-caption">{{ notification.notes }}</v-list-item-subtitle>
              <div v-if="notification.time" class="timestamp">{{ isoDateToCommonDateTime(notification.time) }}</div>
            </v-list-item-content>
            <v-list-item-action>
              <v-spacer />
              <v-btn icon @click.stop="dismissNotification(index)">
                <v-icon small>mdi-close</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import dateHelper from '@/mixins/date-helper'

export default {
  name: 'NotificationsCard',
  props: {},
  mixins: [dateHelper],
  data() {
    return {}
  },
  methods: {
    ...mapActions({
      dismissNotification: 'removeAccountNotification',
      dismissAllNotifications: 'clearAccountNotifications',
    }),
    navigate(notification) {
      if (notification.link) {
        this.$router.push(notification.link).catch(() => {})
      }
    },
  },
  computed: {
    ...mapGetters({
      getUser: 'getUser',
      notifications: 'getAccountNotifications',
    }),
    caughtUp() {
      return this.notifications.length === 0
    },
  },
}
</script>

<style scoped>
.notification-container {
  max-height: 75vh;
  overflow-y: auto;
}

.scrollable-list {
  max-height: 74vh;
  overflow-y: auto;
}

.list-item-content-custom {
  flex: 1 1 auto;
  min-width: 0;
}

.text-caption {
  white-space: normal;
  overflow-wrap: break-word;
  word-break: break-word;
}

.title-container {
  display: flex;
  align-items: center;
}

.timestamp {
  font-size: 10px !important;
  color: grey;
}
</style>
